module.exports = __webpack_public_path__ + "static/img/05049B_2_3_R_20200331_LC.23bf877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05049B_2_3_R_20200331_LC.png
// module id = rdwA
// module chunks = 0